import { roundTo } from '../geometry/epsilon';

export function convertForeignCurrency(price) {
  const exchangeRate = Number(localStorage.getItem('exchangeRate')) ?? 1;
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';

  if (country_code === 'us') {
    return roundTo(price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    // return roundTo(price / exchangeRate).toLocaleString('en-US', {
    //   style: 'currency',
    //   currency: 'USD',
    // });
  }
  return roundTo(price, 0).toLocaleString('vi-VN', {
    style: 'currency',
    currency: 'VND',
  });
}

export function convertToVND(price) {
  const exchangeRate = Number(localStorage.getItem('exchangeRate')) ?? 1;

  return roundTo(price, 0);
}

export function convertToUSD(price) {
  const exchangeRate = Number(localStorage.getItem('exchangeRate')) ?? 1;

  return roundTo(price);
}
